/**
 * Custom exception for AIO expression parsing errors.
 */
export default class AioExpressionParsingException extends Error {
    /**
     * The underlying cause of the exception, if available.
     */
    name;
    message;
    cause;
    /**
     * Constructs a new AioExpressionParsingException.
     *
     * @param message - The error message.
     * @param cause - The underlying cause of the exception (optional).
     */
    constructor(message, cause) {
        super();
        this.name = 'AioExpressionParsingException';
        this.message = message;
        this.cause = cause;
    }
}
